export const getShippingTimeTranslation = (processingTime, translations) => {
  const processingTimeKey = `ITFE_PRODUCT_PAGES_${processingTime.replace('-', '_').toUpperCase()}_PROCESSING`;

  return translations[processingTimeKey];
};
